<template>
    <div class="modal modal-todo modal-convert-to-prospect fade" tabindex="-1" role="dialog" aria-labelledby="convert-to-prospect-modal-label" aria-hidden="true" ref="modal">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Convert to Prospect - {{ name }}</h5>
                    <button type="button" class="close" @click="closeModal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="convertToProspect">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="countries">Choose Country <span class="text-danger">*</span></label>
                                    <v-select id="countries" v-model="selectedCountry" label="label" placeholder="Select" :class="{ 'is-invalid': formErrors.selectedCountry }" :options="countryOptions" :disabled="isLoadingCountries || countryOptions.length === 0" :clearable="false" @input="clearError('selectedCountry')" />
                                    <small v-if="formErrors.selectedCountry" class="text-danger">{{ formErrors.selectedCountry }}</small>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label>Type <span class="text-danger">*</span></label>
                                    <div>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" :class="{ 'is-invalid': formErrors.studentType }" type="radio" id="offshore" value="offshore" v-model="studentType" @change="clearError('studentType')" />
                                            <label class="form-check-label" for="offshore" @click="selectStudentType('offshore')">Offshore</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" :class="{ 'is-invalid': formErrors.studentType }" type="radio" id="onshore" value="onshore" v-model="studentType" @change="clearError('studentType')" />
                                            <label class="form-check-label" for="onshore" @click="selectStudentType('onshore')">Onshore</label>
                                        </div>
                                        <small v-if="formErrors.studentType" class="text-danger d-block">{{ formErrors.studentType }}</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="studentType === 'onshore'" class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label>Visa Expiration <span class="text-danger">*</span></label>
                                    <div class="form-row">
                                        <div class="col">
                                            <v-select v-model="visaExpirationMonth" :class="{ 'is-invalid': formErrors.visaExpirationMonth }" :options="months" :reduce="option => option.value" placeholder="Month" :clearable="false" @input="clearError('visaExpirationMonth')" />
                                            <small v-if="formErrors.visaExpirationMonth" class="text-danger">{{ formErrors.visaExpirationMonth }}</small>
                                        </div>
                                        <div class="col">
                                            <v-select v-model="visaExpirationYear" :class="{ 'is-invalid': formErrors.visaExpirationYear }" :options="visaExpirationYearOptions" placeholder="Year" :clearable="false" @input="clearError('visaExpirationYear')" />
                                            <small v-if="formErrors.visaExpirationYear" class="text-danger">{{ formErrors.visaExpirationYear }}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="tuitionFee">Tuition Fee <span class="text-danger">*</span></label>
                                    <input type="text" id="tuitionFee" class="form-control" :class="{ 'is-invalid': formErrors.tuitionFee }" placeholder="$0.00" v-model="tuitionFee" @input="tuitionFee = tuitionFee.replace(/[^\d.]/g, ''); clearError('tuitionFee');" />
                                    <small v-if="formErrors.tuitionFee" class="text-danger">{{ formErrors.tuitionFee }}</small>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="weeksOrCourses">Week or Courses <span class="text-danger">*</span></label>
                                    <input type="text" id="weeksOrCourses" class="form-control" :class="{ 'is-invalid': formErrors.weeksOrCourses }" v-model="weeksOrCourses" @input="clearError('weeksOrCourses')" />
                                    <small v-if="formErrors.weeksOrCourses" class="text-danger">{{ formErrors.weeksOrCourses }}</small>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="typeSelect">Type <span class="text-danger">*</span></label>
                                    <v-select id="typeSelect" v-model="typeSelect" :class="{ 'is-invalid': formErrors.typeSelect }" :options="typeOptions" placeholder="Select" :clearable="false" @input="clearError('typeSelect')" />
                                    <small v-if="formErrors.typeSelect" class="text-danger">{{ formErrors.typeSelect }}</small>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="monthSelect">Month <span class="text-danger">*</span></label>
                                    <v-select id="monthSelect" v-model="selectedMonth" :class="{ 'is-invalid': formErrors.selectedMonth }" :options="months" :reduce="option => option.value" placeholder="Select" :clearable="false" @input="clearError('selectedMonth')" />
                                    <small v-if="formErrors.selectedMonth" class="text-danger">{{ formErrors.selectedMonth }}</small>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="yearSelect">Year <span class="text-danger">*</span></label>
                                    <v-select id="yearSelect" v-model="selectedYear" :class="{ 'is-invalid': formErrors.selectedYear }" :options="years" placeholder="Select" :clearable="false" @input="clearError('selectedYear')" />
                                    <small v-if="formErrors.selectedYear" class="text-danger">{{ formErrors.selectedYear }}</small>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="course">Course <span class="text-danger">*</span></label>
                                    <input type="text" id="course" class="form-control" :class="{ 'is-invalid': formErrors.course }" placeholder="Input" v-model="course" @input="clearError('course')" />
                                    <small v-if="formErrors.course" class="text-danger">{{ formErrors.course }}</small>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="schools">School <span class="text-danger">*</span></label>
                                    <v-select id="schools" v-model="selectedSchool" label="label" placeholder="Select" :class="{ 'is-invalid': formErrors.selectedSchool }" :options="schoolOptions" :reduce="option => option.value" :disabled="isLoadingSchools || schoolOptions.length === 0" :clearable="false" @input="clearError('selectedSchool')" />
                                    <small v-if="formErrors.selectedSchool" class="text-danger">{{ formErrors.selectedSchool }}</small>
                                </div>
                            </div>
                        </div>
                        
                        <button type="submit" class="btn btn-submit btn-block mt-3 btn-primary" :disabled="isConverting">
                            <span>{{ isConverting ? 'Processing...' : 'Convert' }}</span>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { getCountries, getSchools } from '../../../services/api/to-do';
import { getMonthOptions, getYearOptions } from '../../../utils/helpers';

export default {
    name: 'ConvertToProspectModal',
    components: { 'v-select': vSelect },
    data() {
        const currentYear = new Date().getFullYear();

        return {
            id: 0,
            name: '',
            nationality: '',
            isConverting: false,
            selectedCountry: null,
            selectedSchool: null,
            countryOptions: [],
            schoolOptions: [],
            isLoadingCountries: false,
            isLoadingSchools: false,
            visaExpirationMonth: '',
            visaExpirationYear: '',
            visaExpirationYearOptions: getYearOptions(21),
            studentType: '',
            tuitionFee: '',
            weeksOrCourses: '',
            course: '',
            selectedMonth: '',
            selectedYear: '',
            typeSelect: '',
            typeOptions: ['ELICOS', 'VET', 'High Education'],
            months: getMonthOptions(),
            years: getYearOptions(5),
            formErrors: {}
        }
    },
    mounted() {
        document.body.appendChild(this.$el);
    },
    methods: {
        openModal({ item }) {
            // console.log(item)
            this.id = item.id;
            this.name = item.student_name;
            this.nationality = item.nationality;
            this.validationError = '';
            
            this.$nextTick(() => {
                this.fetchSchools();
                this.fetchCountries();

                $(this.$refs.modal).modal({
                    backdrop: 'static',
                    keyboard: false
                });

            });
        },
        closeModal() {
            $(this.$refs.modal).modal('hide');
            this.resetForm();
        },
        async fetchCountries() {
            this.isLoadingCountries = true;

            try {
                const response = await getCountries();
                const data = response.data.data;

                this.countryOptions = data.map(item => ({
                    label: item.name,
                    value: item.id,
                    original: item
                }));

                if (this.nationality) {
                    const lowercaseCountry = this.nationality.trim().toLowerCase();
                    const matchedCountry = this.countryOptions.find(country => country.label.trim().toLowerCase() === lowercaseCountry);

                    if (matchedCountry) {
                        this.selectedCountry = matchedCountry;
                    }
                }
            } catch (error) {
                console.error('Failed to fetch countries:', error);
            } finally {
                this.isLoadingCountries = false;
            }
        },
        async fetchSchools() {
            this.isLoadingSchools = true;

            try {
                const response = await getSchools();
                const data = response.data.data;

                this.schoolOptions = data.map(item => ({
                    label: item.name,
                    value: item.id,
                    original: item
                }));
            } catch (error) {
                console.error('Failed to fetch schools:', error);
            } finally {
                this.isLoadingSchools = false;
            }
        },
        clearError(field) {
            if (this[field] && this.formErrors[field]) {
                delete this.formErrors[field];
            }
        },
        convertToProspect() {
            this.formErrors = {};

            const requiredFields = [
                'selectedCountry',
                'studentType',
                'tuitionFee',
                'weeksOrCourses',
                'typeSelect',
                'course',
                'selectedMonth',
                'selectedYear',
                'selectedSchool'
            ];

            if (this.studentType === 'onshore') {
                requiredFields.push('visaExpirationMonth', 'visaExpirationYear');
            }

            requiredFields.forEach(field => {
                if (!this[field]) {
                    this.formErrors[field] = 'This field is required';
                }
            });

            if (Object.keys(this.formErrors).length > 0) {
                return;
            }

            this.$emit('save', {
                id: this.id,
                name: this.name,
                nationality: this.selectedCountry?.value,
                visa_month: this.visaExpirationMonth,
                visa_year: this.visaExpirationYear,
                type_student: this.studentType,
                tuition_fee: this.tuitionFee,
                week: this.weeksOrCourses,
                type: this.typeSelect,
                course_name: this.course,
                month: this.selectedMonth,
                year: this.selectedYear,
                school: this.selectedSchool,
            });
        },
        setLoadingState(value) {
            this.isConverting = value;
        },
        selectStudentType(type) {
            this.studentType = type;
            this.clearError('studentType');
        },
        resetForm() {
            this.selectedCountry = null;
            this.selectedSchool = null;
            this.visaExpirationMonth = '';
            this.visaExpirationYear = '';
            this.studentType = '';
            this.tuitionFee = '';
            this.weeksOrCourses = '';
            this.course = '';
            this.selectedMonth = '';
            this.selectedYear = '';
            this.typeSelect = '';
            this.formErrors = {};
            this.isLoadingCountries = false;
            this.isLoadingSchools = false;
        },
    }
}
</script>
